var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.309a9.843 9.843 0 0 1-2.828.775A4.939 4.939 0 0 0 23.337.36a9.857 9.857 0 0 1-3.127 1.195 4.924 4.924 0 0 0-8.39 4.491A13.979 13.979 0 0 1 1.67.9a4.9 4.9 0 0 0-.666 2.476c0 1.708.87 3.215 2.19 4.098a4.904 4.904 0 0 1-2.23-.616v.062a4.927 4.927 0 0 0 3.95 4.828 4.927 4.927 0 0 1-2.224.085 4.929 4.929 0 0 0 4.6 3.419 9.879 9.879 0 0 1-6.115 2.108c-.398 0-.79-.024-1.175-.07a13.936 13.936 0 0 0 7.548 2.213c9.057 0 14.01-7.503 14.01-14.01 0-.213-.005-.425-.015-.637A10.003 10.003 0 0 0 24 2.31Z",
    fill: "#fff"
  })));
};

export default SvgTwitter;